export default "__VITE_ASSET__URwa2CQY__"